import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { UnidadePage } from '../pages/unidade.page';

const UnidadeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/unidade' element={<UnidadePage />} />
    </Routes>
  );
};

export { UnidadeRoutes };
